// src/lib/dashboard/filtrarNegociacoesPorDepartamento.ts
import type { Profile } from '../../../types';
import { canalDaNegociacao } from './departamentoComercial.ts';
import type { DepartamentoComercial } from './departamentoComercial.ts';

// Filtra qualquer lista de linhas com responsavel_id pelo(s) departamento(s)
// comercial(is) do responsável (ver departamentoComercial.ts). Genérico o
// bastante pra funcionar com EventFunnelRow (negociações) ou qualquer outra
// linha que tenha responsavel_id.
//
// `departamentos` é uma lista (multi-seleção) — uma negociação passa se o
// departamento do responsável estiver em QUALQUER um dos selecionados. Lista
// vazia (nada selecionado) é tratada como "sem filtro" (devolve tudo), pra
// nunca deixar a tela vazia por engano — o valor `'todos'` de
// DepartamentoComercial nunca aparece aqui, é só um rótulo de UI.
export function filtrarPorDepartamento<T extends { responsavel_id?: string | null; origem?: string | null }>(
  rows: T[],
  profilesById: Map<string, Profile>,
  departamentos: DepartamentoComercial[]
): T[] {
  if (departamentos.length === 0) return rows;
  // `canalDaNegociacao`, não `getDepartamentoComercial`: negociação de licitação
  // é canal próprio e não depende do responsável — ver departamentoComercial.ts.
  return rows.filter((r) => departamentos.includes(canalDaNegociacao(r, profilesById)));
}
